import {Recherche} from "./Recherche.js";
import {Événements} from "./constantes.js";
import {TableauRecherches} from "./composants/TableauRecherches.js";
import {GestionnaireFavoris} from "./GestionnaireFavoris.js";
import {FenêtreSurgissante} from "./composants/FenêtreSurgissante.js";
import {GestionnaireURL} from "./GestionnaireURL.js";


export class GestionnaireHistorique {

    static MAX_ITEMS = 100;

    recherches = [];

    constructor(constructeurDeRecherche, bd, gestionnaireFavoris) {

        this.bd = bd;
        this.cr = constructeurDeRecherche;
        this.gestionnaireFavoris = gestionnaireFavoris;

        this.conteneur = document.getElementById("historiqueRecherche");

        if (this.conteneur) {

            window.addEventListener("popstate", (e) => this.traitePopstate(e))
            document.addEventListener(Événements.SUPPRESSION_CRITÈRE, (e) => this.traiteSuppressionCritère(e))
            document.addEventListener(Événements.SUPPRESSION_RECHERCHE, (e) => this.traiteSuppressionCritère(e))

            this.tableau = this.conteneur.querySelector(TableauRecherches.nom);
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_HISTORIQUE_SUPPRESSION, (e) => this.supprimeEntréeHistorique(e))
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_HISTORIQUE_PARTAGE, (e) => this.partageEntréeHistorique(e))
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_HISTORIQUE_EXÉCUTER, (e) => this.exécuteEntréeHistorique(e))
            document.addEventListener(TableauRecherches.Événements.RECHERCHE_HISTORIQUE_VIDER, (e) => this.viderHistorique(e))

            customElements.get(FenêtreSurgissante.nom) || customElements.define(FenêtreSurgissante.nom, FenêtreSurgissante);
            this.fenêtreSurgissanteÉlément = new FenêtreSurgissante();
            this.conteneur.appendChild(this.fenêtreSurgissanteÉlément);

            this.rafraichisFavoris();
            document.addEventListener(GestionnaireFavoris.Événements.RECHERCHE_FAVORIS_MODIFIÉS, (e) => this.rafraichisFavoris(e))
        }
    }

    rafraichisFavoris(e) {
        // récupérer la liste des hash des favoris à partir de la bd (chargement/constructeur) pour chargement initial
        this.gestionnaireFavoris.getHashFavoris()
            .then((hashes) => {
                this.tableau.setFavorisHashes(new Set(hashes));
                this.afficheHistorique();
            })
    }

    afficheHistorique() {
        this.getRecherches().then((t) => {
            this.tableau.affiche(t);
        });
    }

    getRecherches() {
        return this.bd.recherches.orderBy('ts').reverse().toArray();
    }

    ajouteEntrée(recherche, nbTotalItems) {

        const {rechercheSérialisée, rechercheURL} = this.gestionnaireFavoris.getRechercheSérialisée(recherche);

        history.pushState({rechercheSérialisée: rechercheSérialisée}, "", rechercheURL);

        this.ajouteEntréeHistorique(recherche, nbTotalItems);
    }

    ajouteEntréeVide() {
        let nouvelleURL = GestionnaireURL.réinitialiseParamsRecherche()
        history.pushState({}, "", nouvelleURL);
    }

    traitePopstate(e) {

        if (!e.state || !e.state.hasOwnProperty("rechercheSérialisée")) {
            return;
        }

        let recherche = Recherche.désérialise(e.state.rechercheSérialisée, this.cr);

        this.cr.chargeNouvelleRecherche(recherche);

    }

    traiteSuppressionCritère(e) {
        if (this.cr.recherche.critères.size === 0) {
            this.ajouteEntréeVide();
        }
    }

    ajouteEntréeHistorique(recherche, nbTotalItems) {

        if (!recherche.hash) {
            recherche = Object.assign(recherche, {hash: Recherche.getHash(recherche)})
        }

        // Ne pas ajouter à l'historique si s'y trouve déjà, juste mettre le ts à jour (via put)
        this.bd.recherches.put(Object.assign(recherche, {
            ts: Date.now(),
            nbTotalItems: nbTotalItems
        }))
            .then(() => {
                    this.bd.recherches.count()
                        .then((nbHistoriqueItems) => {

                            if (nbHistoriqueItems >= GestionnaireHistorique.MAX_ITEMS) {
                                // Supprimer la plus vieille entrée
                                this.bd.recherches.orderBy('ts').reverse().last().then((dernierItem) => {
                                        this.bd.recherches.delete(dernierItem.ts);
                                    }
                                );
                            }

                            this.afficheHistorique();

                        });
                }
            );

    }

    supprimeEntréeHistorique(e) {

        this.bd.recherches.where('ts').equals(e.detail.recherche.ts).delete().then((nbSupp) => {
            // console.log("Suppression de l'historique", nbSupp)
        });

        this.afficheHistorique();
    }

    viderHistorique(e) {
        this.bd.recherches.clear();
        this.afficheHistorique();
    }

    async partageEntréeHistorique(e) {
        const {rechercheSérialisée, rechercheURL} = this.gestionnaireFavoris.getRechercheSérialisée(e.detail.recherche);
        try {
            await navigator.clipboard.writeText(rechercheURL.href);
            this.fenêtreSurgissanteÉlément.informe("URL de la recherche copiée dans le presse-papier.");
        } catch (erreur) {
            this.fenêtreSurgissanteÉlément.avertis(erreur.message);
        }
    }

    async exécuteEntréeHistorique(e) {
        const recherche = e.detail.recherche;
        this.cr.chargeNouvelleRecherche(new Recherche(recherche.critères, recherche.options, recherche.nom));
    }

}
